'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.28282 8.01523C4.91942 7.6761 4.89975 7.10659 5.23888 6.7432L9.06822 2.63982C9.58151 2.08979 10.4534 2.08979 10.9667 2.63981L14.7634 6.70822C15.1026 7.07161 15.0829 7.64112 14.7195 7.98025C14.3561 8.31938 13.7866 8.29972 13.4475 7.93632L10.9004 5.207V13.5809C10.9004 14.0779 10.4974 14.4809 10.0004 14.4809C9.50332 14.4809 9.10038 14.0779 9.10038 13.5809L9.10038 5.2436L6.55485 7.97129C6.21572 8.33468 5.64622 8.35436 5.28282 8.01523ZM3.05435 11.9723C3.05435 11.4752 2.65141 11.0723 2.15435 11.0723C1.6573 11.0723 1.25435 11.4752 1.25435 11.9723V12.8774V12.9418V12.9418C1.25432 14.3013 1.2543 15.4121 1.37221 16.2892C1.49547 17.2059 1.76221 18.0008 2.39665 18.6352C3.03109 19.2696 3.82591 19.5364 4.74266 19.6596C5.6197 19.7775 6.73058 19.7775 8.08999 19.7775H8.09004L8.15446 19.7775H11.8531L11.9175 19.7775H11.9175C13.2769 19.7775 14.3878 19.7775 15.2649 19.6596C16.1816 19.5364 16.9764 19.2696 17.6109 18.6352C18.2453 18.0008 18.5121 17.2059 18.6353 16.2892C18.7532 15.4121 18.7532 14.3012 18.7532 12.9418V12.8774V12.0186C18.7532 11.5215 18.3502 11.1186 17.8532 11.1186C17.3561 11.1186 16.9532 11.5215 16.9532 12.0186V12.8774C16.9532 14.3171 16.9513 15.3063 16.8514 16.0493C16.7549 16.7665 16.5823 17.1181 16.3381 17.3624C16.0938 17.6067 15.7422 17.7793 15.025 17.8757C14.282 17.9756 13.2927 17.9775 11.8531 17.9775H8.15446C6.71478 17.9775 5.72556 17.9756 4.98251 17.8757C4.26535 17.7793 3.9137 17.6067 3.66944 17.3624C3.42519 17.1181 3.25258 16.7665 3.15616 16.0493C3.05626 15.3063 3.05435 14.3171 3.05435 12.8774V11.9723Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
